import * as React from "react";
import type { SVGProps } from "react";
const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M7.482 10.511a10.75 10.75 0 0 0 3.911 2.586l1.993-1.62a.35.35 0 0 1 .402 0l3.7 2.435c.14.086.259.204.347.346a1.096 1.096 0 0 1-.173 1.37l-1.734 1.749c-.248.25-.553.434-.888.535-.335.1-.689.115-1.03.042a18.4 18.4 0 0 1-9.065-4.857 18.35 18.35 0 0 1-4.9-9.084c-.073-.343-.057-.7.045-1.036.101-.336.286-.639.537-.88L2.424.327a1.06 1.06 0 0 1 .865-.321 1.04 1.04 0 0 1 .784.493l2.463 3.73a.345.345 0 0 1 0 .405L4.913 6.625a10.7 10.7 0 0 0 2.57 3.886"
    />
  </svg>
);
export default SvgPhone;
